import type { FunctionComponent } from "react";
import { CampaignBriefCommonPartial } from "../../../partials/common/campaign-brief/campaign-brief.common.partials";

export const CampaignBriefCommonScreen: FunctionComponent = () => {
	return <CampaignBriefCommonPartial />;
};
